import { render, staticRenderFns } from "./MultipleFormGroupCustom.vue?vue&type=template&id=0960d89a&scoped=true"
import script from "./MultipleFormGroupCustom.vue?vue&type=script&lang=js"
export * from "./MultipleFormGroupCustom.vue?vue&type=script&lang=js"
import style0 from "./MultipleFormGroupCustom.vue?vue&type=style&index=0&id=0960d89a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960d89a",
  null
  
)

export default component.exports